var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1174_87919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.11984C12 6.93984 6.935 11.9998 3.12 11.9998C2.285 11.9998 1.505 11.6848 0.930002 11.1098L0.430002 10.5348C-0.149998 9.95484 -0.149998 8.97484 0.455002 8.36984C0.470002 8.35484 1.675 7.42984 1.675 7.42984C2.275 6.85984 3.22 6.85984 3.815 7.42984L4.545 8.01484C6.145 7.33484 7.28 6.19484 8.01 4.53984L7.43 3.80984C6.855 3.21484 6.855 2.26484 7.43 1.66984C7.43 1.66984 8.355 0.464844 8.37 0.449844C8.975 -0.155156 9.955 -0.155156 10.56 0.449844L11.085 0.904844C11.685 1.49984 12 2.27984 12 3.11484V3.11984Z",
    fill: "#3C2212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1174_87919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.d4e535d1b51b09d5b3f1ef4c144074b4.svg";
export { ForwardRef as ReactComponent };